import Generators from "../classes/Generator"
import { Position } from 'reactflow';

export const generators = [
  new Generators({
    alias:"motor-de-inducción-a", 
    svgSrc: "/symbol-assets/MotorSimbolo1.svg", 
    label: "Motor",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
  new Generators({
    alias:"motor-de-inducción-b", 
    svgSrc: "/symbol-assets/MotorSimbolo2.svg", 
    label: "Motor",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
  new Generators({
    alias:"motor-sincrono", 
    svgSrc: "/symbol-assets/MotorSincrono.svg", 
    label: "Motor Síncrono",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
  new Generators({
    alias:"cargas-no-motor", 
    svgSrc: "/symbol-assets/CargaNoMotor.svg", 
    label: "Cargas no-motor",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
  new Generators({
    alias:"cargas-no-motor-B", 
    svgSrc: "/symbol-assets/CargaNoMotorB.svg", 
    label: "Cargador de baterías",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  }),
  new Generators({
    alias:"contactos-trifasicos", 
    svgSrc: "/symbol-assets/ReceptaculoTrifasico.svg", 
    label: "Contactos trifásicos"
  }),
];
